export default __webpack_public_path__ + "static/media/category-icon-Team.72fe1ec5.svg";